export default {
  search: {
    placeholder: "Zoeken...",
    noResult: "Er zijn geen resultaten gevonden.",
  },
  addSearchValue: "`{{value}}` toevoegen",
  autoTitle: {
    fallback: "Selecteer een optie",
    noOptions: "Geen keuze mogelijkheid",
  },
}
